import GlobalSearchInput from '@molecules/GlobalSearchInput/GlobalSearchInput';

export default GlobalSearchInput;
